import { fontSize, fontWeight, lineHeight } from "../../../../../constants/typography";
import { NeutralColors } from "../../../../../constants/colors";
import { Palette } from "../../../../../constants/palettes";
import styled from 'styled-components';
import { colors } from "../../../constants";
export var AccordionHeading = styled.span.withConfig({
  componentId: "sc-1ymj038-0"
})(["display:block;font-weight:", ";font-size:", ";line-height:", ";color:", ";opacity:", ";transition:opacity 0.2s ease-in;cursor:pointer;margin-bottom:16px;&:hover{opacity:0.8;}"], fontWeight.regular, fontSize.small, lineHeight.large, function (props) {
  return colors[props.palette];
}, function (_ref) {
  var active = _ref.active;
  return active ? 0.8 : 1;
});
export var AccordionWrapper = styled.section.withConfig({
  componentId: "sc-1ymj038-1"
})(["position:relative;background-color:", ";display:flex;flex-direction:column;margin-bottom:", ";overflow-y:", ";&:last-child{margin-bottom:", ";}"], function (_ref2) {
  var palette = _ref2.palette;
  return palette === Palette.Negative ? NeutralColors.Ink : NeutralColors.White;
}, function (props) {
  return props.active ? '16px' : '0';
}, function (props) {
  return props.active ? 'visible' : 'hidden';
}, function (props) {
  return props.active ? '0' : '-16px';
});
export var LinksWrapper = styled.section.withConfig({
  componentId: "sc-1ymj038-2"
})(["padding-left:16px;> a{display:", ";}"], function (_ref3) {
  var active = _ref3.active;
  return active ? 'block' : 'none';
});